import styled from "styled-components"

import { Icons, colors, spacing } from "@izettle/otto"

import { fontsToLoad } from "./fonts"

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  color: ${colors.text.default};
  font-family: Zent;
`

export const Logo = styled.img`
  height: 100%;
  max-height: 48px;
  margin: 60px auto;
`

export const Icon = styled.i<{ icon: Icons }>`
  font-family: Dingbatz;
  font-style: normal;
  margin-right: 4px;
  &::after {
    content: "${(props) => String.fromCharCode(props.icon)}";
  }
`

export const OptOutBoxContent = styled.div``

export const OptOutBox = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 40px;
  width: 100%;
  max-width: 640px;
  background: ${colors.background.default};
  border: 1px solid ${colors.border.divider};
  border-radius: 8px;
`

export const Divider = styled.hr`
  margin-top: 40px;
  margin-left: -40.5px;
  margin-right: -40.5px;
  border: 0.5px solid ${colors.border.divider};
`

export const OptOutButton = styled.button`
  background: ${colors.action.primary.background.default};
  border-radius: 8px;
  color: ${colors.action.primary.text.default};
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  outline: none;
  border-style: none;
  padding: 16px 32px;
  margin-top: ${spacing.small};
  &:hover,
  &:active {
    background: ${colors.action.primary.background.hover};
    color: ${colors.action.primary.text.hover};
    outline: none;
    border-style: none;
  }
`

export const MainTitle = styled.h3`
  font-size: 26px;
  margin-top: 40px;
  margin-bottom: 16px;
`

export const Fonts = styled.style`
  ${fontsToLoad}
`

export const OptOutText = styled.p``

export const FaqTitle = styled.h5`
  font-size: 20px;
  margin-top: 40px;
  margin-bottom: 8px;
`

export const FooterLink = styled.a`
  color: ${colors.text.highlight};
`
export const SupportLink = styled.a`
  color: ${colors.text.highlight};
`

export const Footer = styled.div``

export const FooterLinkWrapper = styled.div`
  margin-bottom: ${spacing.xxSmall};
`

export const StatusTitle = styled(MainTitle)<{ status: string }>`
  color: ${(props) =>
    props.status === "success" ? colors.text.success : colors.text.error};
`
